import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as groupAction from './../../../../actions/groupAction';
import ProductFeed from './ProductFeed';

const mapStateToProps = state => {
  return {
    groupState: state.groupReducer,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    exportProductFeed: (params) => dispatch(groupAction.exportProductFeedAction(params)),
  }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ProductFeed));
